import type { FieldRenderProps } from "react-final-form";

type TFieldMetaState<FieldValue> = FieldRenderProps<FieldValue>["meta"];

function mapFinalFormMetaToErrorProps<FieldValue>(meta: TFieldMetaState<FieldValue>): {
  error: boolean;
  helperText: string;
} {
  const { submitError, error: errorArg } = meta;

  const error = Boolean(submitError) || Boolean(errorArg);
  const helperText = submitError || errorArg;

  return meta.touched && { error, helperText };
}

export default mapFinalFormMetaToErrorProps;
